module.exports = __webpack_public_path__ + "assets/raleigh-recruiters-process-rainmakers-3.01df7d71.png";